import { FormattedMessage } from 'react-intl';
import RecurlyAccountStatus from 'types/RecurlyAccountStatus';
import useUser from 'hooks/useUser';
import * as styles from './ProStatus.module.scss';

type Props = {
  recurlyAccountStatus: RecurlyAccountStatus;
};

function RenewalDateLabel({ recurlyAccountStatus }: Props) {
  const user = useUser();
  if (!user.expirationDate) {
    return <FormattedMessage defaultMessage="Unknown" />;
  }

  const expirationDate = new Date(user.expirationDate);

  if (user.subscription?.trial) {
    if (recurlyAccountStatus === RecurlyAccountStatus.Active) {
      return (
        <FormattedMessage defaultMessage="Your trial will convert to an annual plan on {expirationDate, date, long}" values={{ expirationDate }} />
      );
    }

    if (recurlyAccountStatus === RecurlyAccountStatus.Cancelled) {
      return <FormattedMessage defaultMessage="Your trial will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
    }
  }

  // after 7th day of trial
  if (recurlyAccountStatus === RecurlyAccountStatus.Active) {
    return <FormattedMessage defaultMessage="Your subscription will renew on {expirationDate, date, long}" values={{ expirationDate }} />;
  }

  // cancelled / no auto renew
  return <FormattedMessage defaultMessage="Your subscription will expire on {expirationDate, date, long}" values={{ expirationDate }} />;
}

function RenewalDate({ recurlyAccountStatus }: Props) {
  return (
    <div className={styles.settingsPro}>
      <span className={styles.subtitle}>
        <FormattedMessage defaultMessage="Renewal Date:" />
      </span>
      <RenewalDateLabel recurlyAccountStatus={recurlyAccountStatus} />
    </div>
  );
}

export default RenewalDate;
